import API from './api';

export default class OfferApi {
  static get(id, params) {
    return API.get(`/advertisers/offers/${id}`, params);
  }
}
